import { render, staticRenderFns } from "./visit-follow-import-details.vue?vue&type=template&id=43570f87&scoped=true"
import script from "./visit-follow-import-details.vue?vue&type=script&lang=ts"
export * from "./visit-follow-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43570f87",
  null
  
)

export default component.exports